
import { useState, useEffect } from 'react';
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";

export const useFollowStats = () => {
  const { user } = useAuth();
  const { toast } = useToast();
  const [followersCount, setFollowersCount] = useState(0);
  const [followingCount, setFollowingCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    
    const fetchFollowStats = async () => {
      try {
        setLoading(true);
        
        // Count followers (users who follow the current user)
        const { count: followers, error: followersError } = await supabase
          .from('user_follows')
          .select('*', { count: 'exact', head: true })
          .eq('following_id', user.id);
          
        if (followersError) throw followersError;
        
        // Count following (users the current user follows)
        const { count: following, error: followingError } = await supabase
          .from('user_follows')
          .select('*', { count: 'exact', head: true })
          .eq('follower_id', user.id);
          
        if (followingError) throw followingError;
        
        setFollowersCount(followers || 0);
        setFollowingCount(following || 0);
        
      } catch (error) {
        console.error("Error fetching follow stats:", error);
        toast({
          title: "Error",
          description: "Failed to load follow statistics",
          variant: "destructive"
        });
      } finally {
        setLoading(false);
      }
    };
    
    fetchFollowStats();
  }, [user, toast]);

  return {
    followersCount,
    followingCount,
    loading
  };
};
